import ModalComponent from "../../../shared/components/Modals/ModalComponent";
import ModalBody from "../../../shared/components/Modals/ModalBody";
import ReactPlayer from "react-player";
import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import "../../../shared/scss/librariesOverrides/antdOverrides/_modal.scss";
import playIcon from "../../../shared/assets/images/Play.svg";
import MyraUI from "../../../shared/assets/images/MyraUI.png";
import { selectIsRecordedInterviewModalOpen, selectRecordedVideoUrl, setIsRecordedInterviewModalOpen} from "../../interview/slice/interviewSlice";

const RecordedInterview = () => {
    const [isPlayingVideo, setIsPlayingVideo] = useState(false);
    const isOpen = useSelector(selectIsRecordedInterviewModalOpen);
    const recordedVideoUrl = useSelector(selectRecordedVideoUrl)
    const dispatch = useDispatch();

    const handleCloseModal = () => {
        setIsPlayingVideo(false);
        dispatch(setIsRecordedInterviewModalOpen(false));
    };

    return (
        <ModalComponent
            key={isOpen ? "open" : "closed"}
            className="!max-w-[90vw] sm:!max-w-3xl md:!max-w-4xl lg:!max-w-4xl xl:!max-w-5xl !w-full !p-0 interview-modal"
            visibleModal={isOpen}
            handleCloseModal={handleCloseModal}
            content={
                <ModalBody title={null} className="!p-0">
                    <section
                        aria-label="Recorded Interview Video"
                        className="w-full h-[79vh] aspect-video bg-black rounded-lg overflow-hidden flex items-center justify-center"
                    >
                        <figure className="relative w-full h-full flex items-center justify-center">
                            {isOpen && (
                                <ReactPlayer
                                    url={recordedVideoUrl}
                                    className="!w-full !h-full cursor-pointer interview-video"
                                    playing={isPlayingVideo}
                                    controls={isPlayingVideo}
                                    light={
                                        <div className="flex items-center justify-center w-full h-full bg-black">
                                            <img
                                                src={MyraUI}
                                                alt="Interview preview"
                                                className="w-auto h-auto object-contain"
                                            />
                                        </div>
                                    }
                                    playIcon={
                                        <img
                                            src={playIcon}
                                            alt="Play interview video"
                                            className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-[9999] w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16"
                                        />
                                    }
                                    onClickPreview={() => setIsPlayingVideo(true)}
                                />
                            )}
                            <figcaption className="sr-only">
                                Recorded interview playback interface
                            </figcaption>
                        </figure>
                    </section>
                </ModalBody>
            }
        />
    );
};

export default RecordedInterview;
